import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API_ROOT } from "../service/Services";
import Spinner from "../components/Spinner";
import { FaInfoCircle } from "react-icons/fa";

export default function Leads() {
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [toast, setToast] = useState({ message: "", visible: false });

  const [filterType, setFilterType] = useState("");

  const authHeaders = useMemo(
    () => ({ headers: { authorization: `Bearer ${localStorage.getItem("token")}` } }),
    []
  );

  const loadInit = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_ROOT}/leads`, authHeaders);
      setLeads(res.data?.leads || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInit();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-GB");
  };

  const todayStr = new Date().toISOString().split("T")[0];

  const filteredLeads = leads
    .filter((lead) => {
      const matchType =
        filterType.trim() === ""
          ? true
          : lead.typeOfLead.toLowerCase().includes(filterType.toLowerCase());

      const matchToday = lead.reminderDate && lead.reminderDate.split("T")[0] <= todayStr;
      return matchType && matchToday;
    })
    .sort((a, b) => new Date(b.reminderDate) - new Date(a.reminderDate));

  return (
    <div className="flex flex-col gap-6 w-full relative">
      {loading && <Spinner />}

      {toast.visible && (
        <div className="fixed top-5 right-5 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50 transition-all duration-300">
          {toast.message}
        </div>
      )}

      <div className="card p-4 shadow-md rounded-lg bg-white">
        <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
          <div className="flex items-center gap-3">
            <h3 className="text-lg font-semibold">Follow-ups</h3>
            <input
              type="text"
              placeholder="Search by Lead Type..."
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              className="border px-3 py-1 rounded-md w-60"
            />
          </div>
        </div>

        <div className="overflow-x-auto">
          <div className="min-w-[1000px] overflow-y-auto max-h-[400px] relative">
            <table className="table-auto w-full border border-gray-200 text-sm">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="border px-2 py-1">Date</th>
                  <th className="border px-2 py-1">Type</th>
                  <th className="border px-2 py-1">Company</th>
                  <th className="border px-2 py-1">Name</th>
                  <th className="border px-2 py-1">Status</th>
                  <th className="border px-2 py-1">Remark</th>
                  <th className="border px-2 py-1">Reminder Date</th>
                  <th className="border px-2 py-1">Lead Type</th>
                </tr>
              </thead>
              <tbody>
                {filteredLeads.length > 0 ? (
                  filteredLeads.map((lead) => (
                    <tr key={lead._id} className="hover:bg-gray-50 relative">
                      <td className="border px-2 py-1">{formatDate(lead.date)}</td>
                      <td className="border px-2 py-1">{lead.typeOfLead}</td>
                      <td className="border px-2 py-1">{lead.companyName}</td>
                      <td className="border px-2 py-1 relative">
                        <div className="flex items-center gap-2">
                          <span>{lead.contactName}</span>
                          <div className="relative group">
                            <FaInfoCircle className="text-green-400 hover:text-green-600 cursor-pointer" />
                            <div className="absolute left-6 top-0 bg-white border border-gray-300 shadow-xl rounded-lg p-4 text-sm w-80 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity z-50">
                              <p><strong>Email:</strong> {lead.contactEmail}</p>
                              <p><strong>Phone:</strong> {lead.contactPhone}</p>
                              <p><strong>Designation:</strong> {lead.designation}</p>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="border px-2 py-1">{lead.status}</td>
                      <td className="border px-2 py-1">{lead.remark}</td>
                      <td className="border px-2 py-1">{lead.reminderDate ? formatDate(lead.reminderDate) : "-"}</td>
                      <td className="border px-2 py-1">
                        <span
                          className={`px-1.5 py-0.5 rounded-full text-white text-sm font-medium ${lead.leadType === "Active" ? "bg-green-400" : "bg-red-400"}`}
                        >
                          {lead.leadType || "Active"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center p-2 text-gray-500">
                      No follow-ups for today
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
